import { z } from 'zod';

import {
  PrintStatusSchema,
  PurchaseCancellationSchema,
  PurchaseCommittedSnapshotSchema,
  PurchaseLimitLedgerEntrySchema,
  PurchasePostCommitNoteSchema,
  StationContextRefSchema,
} from '../../purchases/purchases.schema.js';
import type {
  PurchaseCanceledEventPayload,
  PurchaseCommittedEventPayload,
  PurchaseLimitLedgerEntryRecordedEventPayload,
  PurchaseNoteAddedEventPayload,
  PurchasePrintStatusUpdatedEventPayload,
} from './purchases-sync.dto.js';

export const PurchaseCommittedEventPayloadSchema: z.ZodType<PurchaseCommittedEventPayload> =
  z.object({
    schemaVersion: z.union([z.literal(1), z.literal(2)]),
    purchase: PurchaseCommittedSnapshotSchema,
    printStatus: PrintStatusSchema,
  });

export const PurchaseCanceledEventPayloadSchema: z.ZodType<PurchaseCanceledEventPayload> = z.object(
  {
    schemaVersion: z.literal(1),
    cancellation: PurchaseCancellationSchema,
  },
);

export const PurchasePrintStatusUpdatedEventPayloadSchema: z.ZodType<PurchasePrintStatusUpdatedEventPayload> =
  z.object({
    schemaVersion: z.union([z.literal(1), z.literal(2)]),
    purchaseId: z.uuid(),
    station: StationContextRefSchema,
    printStatus: PrintStatusSchema,
    actorUserId: z.uuid(),
  });

export const PurchaseNoteAddedEventPayloadSchema: z.ZodType<PurchaseNoteAddedEventPayload> =
  z.object({
    schemaVersion: z.literal(1),
    note: PurchasePostCommitNoteSchema,
  });

export const PurchaseLimitLedgerEntryRecordedEventPayloadSchema: z.ZodType<PurchaseLimitLedgerEntryRecordedEventPayload> =
  z.object({
    schemaVersion: z.literal(1),
    entry: PurchaseLimitLedgerEntrySchema,
  });
